import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";
import { useI18n } from "../i18n";
import { toast } from "sonner";
import { Trophy } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success(t("welcome_back"));
      nav("/matches");
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-12" data-testid="login-page">
      <div className="w-full max-w-md border border-white/10 bg-[#0d0d0d] p-8 fade-up">
        <div className="flex items-center gap-2 mb-8">
          <div className="w-6 h-6 flex items-center justify-center bg-[#00D37F] text-black">
            <Trophy className="w-3.5 h-3.5" strokeWidth={2.5} />
          </div>
          <span className="text-[11px] uppercase tracking-[0.3em] font-mono font-bold text-[#00D37F]">
            POLLAGOL 2026
          </span>
        </div>
        <h1 className="font-display text-5xl sm:text-6xl">{t("welcome_back")}</h1>
        <p className="text-sm text-white/50 mt-2 font-mono uppercase tracking-wider">{t("login")}</p>

        <form onSubmit={onSubmit} className="mt-8 space-y-4" data-testid="login-form">
          <div>
            <label className="text-[10px] uppercase tracking-[0.3em] text-white/60 font-mono font-bold">
              {t("email")}
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="login-email"
              className="w-full mt-2 h-12 px-3 bg-black border border-white/20 focus:border-[#00D37F] focus:outline-none focus:ring-1 focus:ring-[#00D37F] text-white text-sm"
              autoComplete="email"
            />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-[0.3em] text-white/60 font-mono font-bold">
              {t("password")}
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="login-password"
              className="w-full mt-2 h-12 px-3 bg-black border border-white/20 focus:border-[#00D37F] focus:outline-none focus:ring-1 focus:ring-[#00D37F] text-white text-sm"
              autoComplete="current-password"
            />
          </div>
          {error && (
            <div
              data-testid="login-error"
              className="text-xs text-[#FF2D45] border border-[#FF2D45]/30 bg-[#FF2D45]/10 px-3 py-2 font-mono"
            >
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full h-13 py-3.5 bg-[#00D37F] hover:bg-[#00E78B] text-black font-head text-base transition-colors disabled:opacity-50"
          >
            {loading ? "…" : t("login")}
          </button>
        </form>

        <p className="mt-6 text-xs text-white/50 font-mono">
          {t("dont_have_account")}{" "}
          <Link to="/register" className="text-[#00D37F] hover:underline font-bold" data-testid="to-register">
            {t("register")}
          </Link>
        </p>
      </div>
    </div>
  );
}
